import detailsReducer from './detailsReducer';

export * from './detailsAction';
export default detailsReducer;
